<template>
    <v-dialog max-width="500px" v-model="isOpen" persistent>
        <v-form :disabled="!isEditable">
            <v-card class="pa-4">
                <v-row>
                    <v-col md="12">
                        <h1 class="pl-md-1 font-weight-light primary--text">
                            Agendar
                        </h1>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="12" cols="12">
                        <v-card outlined class="px-md-4">
                            <v-row>
                                <v-col md="12" class="mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Comercial
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col md="12" class="mb-md-n4">
                                    <v-combobox
                                        clearable
                                        chips
                                        hide-selected
                                        :items="comerciales"
                                        item-value="item"
                                        item-text="nombreCompleto"
                                        v-model="form.comercial"
                                        label="Comercial"
                                    >
                                        <template #item="{ item }">
                                            <v-row>
                                                <v-col cols="8">
                                                    {{ item.nombreCompleto }}
                                                </v-col>
                                                <v-col
                                                    v-if="item.estado"
                                                    cols="4"
                                                >
                                                    <v-chip
                                                        label
                                                        :color="
                                                            estadoComercial[
                                                                item.estado
                                                            ]
                                                        "
                                                        medium
                                                        class="
                                                            d-flex
                                                            justify-center
                                                            overline
                                                        "
                                                    >
                                                        {{ item.estado }}
                                                    </v-chip>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template #selection="{ item }">
                                            <v-chip
                                                :color="
                                                    !isEditable
                                                        ? 'pink lighten-3'
                                                        : 'pink'
                                                "
                                                class="white--text"
                                            >
                                                <v-icon left size="20">
                                                    mdi-account-circle-outline
                                                </v-icon>
                                                {{ item.nombreCompleto }}
                                            </v-chip>
                                        </template>
                                    </v-combobox>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="12" cols="12">
                        <v-card outlined class="px-md-4">
                            <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Fecha y hora
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col md="12" class="mb-md-n4">
                                    <v-datetime-picker
                                        label="Fecha y hora a agendar"
                                        v-model="fechaAgendado"
                                        :date-picker-props="dateProps"
                                        :time-picker-props="timeProps"
                                    >
                                        <template v-slot:dateIcon>
                                            <v-icon>mdi-calendar-range</v-icon>
                                        </template>
                                        <template v-slot:timeIcon>
                                            <v-icon>mdi-clock</v-icon>
                                        </template>
                                        <template
                                            slot="actions"
                                            slot-scope="{ parent }"
                                        >
                                            <div style="width: 100% !important">
                                                <v-btn
                                                    color="primary lighten-2"
                                                    dark
                                                    icon
                                                    large
                                                    @click="openInfo"
                                                >
                                                    <v-icon>
                                                        mdi-map-legend
                                                    </v-icon>
                                                </v-btn>
                                                <Legend :items="legend" />
                                            </div>
                                            <v-btn
                                                color="error lighten-1"
                                                outlined
                                                @click.native="
                                                    parent.clearHandler
                                                "
                                                >Cancelar</v-btn
                                            >
                                            <v-btn
                                                color="success darken-1"
                                                @click="parent.okHandler"
                                                >Aceptar</v-btn
                                            >
                                        </template>
                                    </v-datetime-picker>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="12" cols="12">
                        <v-card outlined class="px-md-4">
                            <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Notas
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col md="12" class="mb-md-n4">
                                    <v-textarea
                                        append-icon="mdi-comment"
                                        class="mx-2"
                                        label="Comentarios"
                                        rows="5"
                                        v-model="notas"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-card-actions class="justify-end mb-md-n4">
                    <v-btn
                        color="primary"
                        depressed
                        v-if="isEditable"
                        @click="save"
                    >
                        Guardar
                    </v-btn>
                    <v-btn text color="red" @click="closeForm()">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getDefaultStrDate } from '@/util/libUtil';
import defaultAtencionAgendadoForm from '@/util/atenciones/defaultAtencionAgendadoForm';
import Legend from '@/components/GerenciaTeletrabajo/ComercialesTable/Legend.vue';

export default {
    name: 'ScheduleForm',
    components: {
        Legend,
    },
    data: () => ({
        dialog: false,
        legend: [
            {
                title: 'Verde',
                icon: 'mdi-circle',
                color: 'green',
                text: 'Clientes agendados máximo 3',
            },
            {
                title: 'Amarillo',
                icon: 'mdi-circle',
                color: 'yellow',
                text: 'Clientes agendados máximo 6',
            },
            {
                title: 'Naranja',
                icon: 'mdi-circle',
                color: 'orange',
                text: 'Clientes agendados máximo 10',
            },
            {
                title: 'Rojo',
                icon: 'mdi-circle',
                color: 'red',
                text: 'Más de 10 clientes agendados',
            },
        ],
        estadoComercial: {
            ALTA: 'success',
            BAJA: 'warning',
            INACTIVO: 'error',
            VACACIONES: 'blue',
        },
        activePicker: null,
        menu: false,
        ocurrencesDate: {},
        dateProps: {
            min: new Date(Date.now()).toISOString().substr(0, 10),
            'year-icon': 'mdi-calendar-blank',
            'prev-icon': 'mdi-skip-previous',
            'next-icon': 'mdi-skip-next',
            events: null,
            'event-color': null,
            locale: 'es-es',
            elevation: '2',
        },
        timeProps: {
            format: '24hr',
            min: '7:00',
            max: '22:00',
            locale: 'es-es',
            elevation: '2',
        },
    }),
    computed: {
        isOpen: {
            get() {
                return this.$store.state.teletrabajo.ScheduleForm['isOpen'];
            },
            set(val) {
                this.$store.state.teletrabajo.ScheduleForm['isOpen'] = val;
            },
        },
        notas: {
            get() {
                return this.$store.state.teletrabajo.ScheduleForm.form.notas;
            },
            set(val) {
                this.$store.state.teletrabajo.ScheduleForm.form.notas = val;
            },
        },
        fechaAgendado: {
            get() {
                return this.$store.state.teletrabajo.ScheduleForm.form.agendado
                    .fechaAgendado
                    ? new Date(
                          this.$store.state.teletrabajo.ScheduleForm.form.agendado.fechaAgendado
                      )
                    : '';
            },
            set(val) {
                this.$store.state.teletrabajo.ScheduleForm.form.agendado.fechaAgendado =
                    val;
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
            form: (state) => state.ScheduleForm.form,
            isEditable: (state) => state.ScheduleForm['isEditable'],
        }),
        ...mapState('areaPersonal/calendario', {
            agendados: (state) => state.agendados,
        }),
    },
    methods: {
        openInfo() {
            this.$store.commit('util/isOpenLegendDialog', true);
        },
        colorCountsDateAgendado(date) {
            if (this.ocurrencesDate[date] <= 3) {
                return 'green';
            } else if (this.ocurrencesDate[date] <= 6) {
                return 'yellow';
            } else if (this.ocurrencesDate[date] <= 10) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        clearFields() {
            this.$store.state.teletrabajo.ScheduleForm['form'] = this.clone(
                defaultAtencionAgendadoForm
            );
        },
        closeForm() {
            this.$store.state.teletrabajo.ScheduleForm.isOpen = false;

            if (
                this.$router.currentRoute.fullPath == '/areapersonal/calendario'
            )
                this.updateCalendar();
            if (this.$router.currentRoute.fullPath == '/dashBoard')
                this.updateDashboardScheduled();
        },
        async updateCalendar() {
            // await this.$store.dispatch(
            // 	'areaPersonal/calendario/fetchAgendados'
            // );
        },
        async updateDashboardScheduled() {
            await this.$store.dispatch('/dashboard/fetchAgendados');
        },
        save() {
            this.addScheduled().then(() => {
                this.closeForm();
                this.clearFields();
            });
        },
        ...mapActions('teletrabajo', {
            addScheduled: 'addScheduled',
        }),
        ...mapActions('areaPersonal/calendario', ['fetchAgendados']),
    },
    watch: {
        comerciales: {
            immediate: true,
            handler: function () {
                this.form.comercial = this.comerciales.find(
                    ({ id }) => id == this.$store.state.login.id
                );
            },
        },
        isOpen: {
            immediate: true,
            handler: function (val) {
                if (val) {
                    var date = new Date();
                    var firstDay = new Date();
                    var lastDay = new Date(
                        date.getFullYear(),
                        date.getMonth() + 3,
                        0
                    );
                    this.fetchAgendados({
                        start: { date: getDefaultStrDate(firstDay) },
                        end: { date: getDefaultStrDate(lastDay) },
                    }).then(() => {
                        const agendadosProcess = this.agendados.map(
                            ({ servicio }) =>
                                new Date(servicio.fecha_agendado.split('T')[0])
                                    .toISOString()
                                    .substr(0, 10)
                        );
                        this.dateProps.events = agendadosProcess;
                        for (const agendado of agendadosProcess) {
                            this.ocurrencesDate[agendado] = this.ocurrencesDate[
                                agendado
                            ]
                                ? this.ocurrencesDate[agendado] + 1
                                : 1;
                        }
                        this.dateProps['event-color'] = (date) =>
                            this.colorCountsDateAgendado(
                                new Date(date.split('T')[0])
                                    .toISOString()
                                    .substr(0, 10)
                            );
                    });
                }
            },
        },
    },
};
</script>
<style>
.v-date-picker-table {
    margin-bottom: 20px;
}
</style>
